import he from "he";
import React from 'react';
import { useTranslation } from 'react-i18next';
import style from './style.module.scss';

const Tags = ({ tags }) => {
	// React i18next
	const { t } = useTranslation();

	return (
		<div className={style.tagsContainer} >
			<h2 className={style.title}>{t('Tags')}</h2>

			<div className={style.tags}>
				{tags.map((tag, _) =>
					<h3 key={tag.term_id} className={style.tag}>
						{he.decode(tag.name)}
					</h3>
				)}
			</div>
		</div>
	);
}

export default Tags;
